import React from 'react'
import CancellationPolicyDE from './cancellationPolicy/CancellationPolicyDE'
import CancellationPolicyEN from './cancellationPolicy/CancellationPolicyEN'
import useLanguage from '@hooks/useLanguage.hook'

const CancelationPolicy = () => {
    const [lng] = useLanguage()

    return <div>{lng.includes('en') ? <CancellationPolicyEN /> : <CancellationPolicyDE />}</div>
}

export default CancelationPolicy
